<template>
<!--道路信息表单页面-->
<el-form class="parForm" status-icon ref="road" label-width="55%" v-loading="loading">

  <div class="formDo">
    <!--按钮操作区-->
    <el-form-item label="参与方编号" v-if="this.participantsNum === '2'">
      <el-select v-model="parNum" :disabled="number">
        <el-option v-for="item in par_num" :key="item.value" :label="item.label" :value="item.label"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="参与方类型">
      <el-select v-model="type">
        <el-option v-for="item in type_num" :key="item.value" :label="item.label" :value="item.label"></el-option>
      </el-select>
    </el-form-item>
  </div>

  <div class="formMsg" v-if="this.parNum === '参与方一' && this.type === '车'">
    <!--表单组-->
    <car-form :formItem="car"></car-form>
  </div>

  <div class="formMsg" v-if="this.parNum === '参与方一' && this.type === '二轮车'">
    <!--表单组-->
    <two-wheel-form :formItem="twoWheel"></two-wheel-form>
  </div>

  <div class="formMsg" v-if="this.parNum === '参与方一' && this.type === '人'">
    <!--表单组-->
    <person-form :formItem="person"></person-form>
  </div>

  <div class="formMsg" v-if="this.parNum === '参与方二' && this.type === '车'">
    <!--表单组-->
    <car_copy-form :formItem="car_copy"></car_copy-form>
  </div>

  <div class="formMsg" v-if="this.parNum === '参与方二' && this.type === '二轮车'">
    <!--表单组-->
    <two-wheel_copy-form :formItem="twoWheel_copy"></two-wheel_copy-form>
  </div>

  <div class="formMsg" v-if="this.parNum === '参与方二' && this.type === '人'">
    <!--表单组-->
    <person_copy-from :formItem="person_copy"></person_copy-from>
  </div>


  <div class="formButton">
    <!--按钮操作区-->
    <el-button-group>
      <el-button @click="lastStep"><i class="el-icon-arrow-right el-icon-arrow-left"></i>上一步</el-button>
      <el-button icon="el-icon-check" :plain="true" @click="submit">保存信息</el-button>
      <el-button :disabled="next" @click="save">创建案例<i class="el-icon-arrow-right el-icon-check"></i></el-button>
    </el-button-group>
  </div>

</el-form>
</template>

<script>
import qs from 'qs'
import bus from './bus'
import arrayData from '../assets/javascript/dataProcess'
import carForm from '../assets/components/form'
import twoWheelForm from '../assets/components/form'
import personForm from '../assets/components/form'
import car_copyForm from '../assets/components/form'
import twoWheel_copyForm from '../assets/components/form'
import person_copyFrom from '../assets/components/form'

export default {
  name: "newCase_par",
  components:{
    carForm,
    twoWheelForm,
    personForm,
    car_copyForm,
    twoWheel_copyForm,
    person_copyFrom
  },
  data() {
    return {
      /*加载动画*/
      loading: false,
      caseNumber: '',
      participantsNum: "",
      number: true,
      next: true,
      parNum: '参与方一',
      par_num: [{
          label: "参与方一",
          value: "1"
        },
        {
          label: "参与方二",
          value: "2"
        }
      ],
      type: '车',
      type_num: [{
          label: "车",
          value: "1"
        },
        {
          label: "二轮车",
          value: "2"
        },
        {
          label: "人",
          value: "3"
        }
      ],
      person: [],
      person_copy: [],
      car: [],
      car_copy: [],
      twoWheel: [],
      twoWheel_copy: [],
    }
  },
  methods: {
    /*获取要提交的值*/
    getValue(name) {
      let getdata = {};
      for (let i = 0; i < name.length; i++) {
        let value = name[i].value;
        getdata[name[i].name] = value;
      }
      return getdata;
    },
    /*发送要提交的值*/
    postValue(url, msg, value) {
      this.loading = true;
      this.$http.post(
          '/nais/' + url,
          qs.stringify(value), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        )
        .then((res) => {
          this.$message({
            message: msg + "保存成功",
            type: 'success',
            center: true,
            duration: 1000
          });
          this.$nextTick(
            this.loading = false,
          );
        })
        .catch((err) => {
          console.log(err);
          this.$nextTick(
            this.loading = false,
          );
        });
    },
    /*验证是否为空函数*/
    isNull(num, name) {
      for (let i = 0; i < num; i++) {
        if (name[i].value === "") {
          this.$set(name[i], "warning", 1);
          this.$set(name[i], "warningMsg", "必填信息不得为空");
        }
      }
    },
    /*表单提交函数*/
    submit() {
      if (this.participantsNum === "1") {
        /*当参与方数量为一的时候*/
        let formdata = {};
        /*判断参与方类型*/
        if (this.type === "车") {
          if (this.car[0].value === "" || this.car[1].value === "" || this.car[2].value === "") {
            this.isNull(3, this.car)
          } else {
            formdata = this.getValue(this.car);
            this.postValue('car', '参与方信息一', formdata);
          }
        } else if (this.type === "二轮车") {
          if (this.twoWheel[0].value === "" || this.twoWheel[1].value === "" || this.twoWheel[2].value === "" || this.twoWheel[3].value === "" || this.twoWheel[4].value === "") {
            this.isNull(5, this.twoWheel)
          } else {
            formdata = this.getValue(this.twoWheel);
            this.postValue('twowheelvehicle', '参与方信息一', formdata);
          }
        } else {
          if (this.person[0].value === "" || this.person[1].value === "" || this.person[2].value === "" || this.person[3].value === "" || this.person[4].value === "" || this.person[5].value === "") {
            this.isNull(6, this.person)
          } else {
            formdata = this.getValue(this.person);
            this.postValue('person', '参与方信息一', formdata);
          }
        }
        this.next = false;
        console.log(formdata);
        bus.$emit('parNext', 4);
      }
      /*当参与方数量为二的时候*/
      else {
        /*先判断当前参与方*/
        let formdata = {};
        if (this.parNum === "参与方一") {
          if (this.type === "车") {
            if (this.car[0].value === "" || this.car[1].value === "" || this.car[2].value === "") {
              this.isNull(3, this.car)
            } else {
              formdata = this.getValue(this.car);
              this.postValue('car', '参与方信息一', formdata);
            }
          } else if (this.type === "二轮车") {
            if (this.twoWheel[0].value === "" || this.twoWheel[1].value === "" || this.twoWheel[2].value === "" || this.twoWheel[3].value === "" || this.twoWheel[4].value === "") {
              this.isNull(5, this.twoWheel)
            } else {
              formdata = this.getValue(this.twoWheel);
              this.postValue('twowheelvehicle', '参与方信息一', formdata);
            }
          } else {
            if (this.person[0].value === "" || this.person[1].value === "" || this.person[2].value === "" || this.person[3].value === "" || this.person[4].value === "" || this.person[5].value === "") {
              this.isNull(6, this.person)
            } else {
              formdata = this.getValue(this.person);
              this.postValue('person', '参与方信息一', formdata);
            }
          }
          this.number = false;
        } else {
          if (this.type === "车") {
            if (this.car_copy[0].value === "" || this.car_copy[1].value === "" || this.car_copy[2].value === "") {
              this.isNull(3, this.car_copy)
            } else {
              formdata = this.getValue(this.car_copy);
              this.postValue('car', '参与方信息二', formdata);
            }
          } else if (this.type === "二轮车") {
            if (this.twoWheel_copy[0].value === "" || this.twoWheel_copy[1].value === "" || this.twoWheel_copy[2].value === "" || this.twoWheel_copy[3].value === "" || this.twoWheel_copy[4].value === "") {
              this.isNull(5, this.twoWheel_copy)
            } else {
              formdata = this.getValue(this.twoWheel_copy);
              this.postValue('twowheelvehicle', '参与方信息二', formdata);
            }
          } else {
            if (this.person_copy[0].value === "" || this.person_copy[1].value === "" || this.person_copy[2].value === "" || this.person_copy[3].value === "" || this.person_copy[4].value === "" || this.person_copy[5].value === "") {
              this.isNull(6, this.person_copy)
            } else {
              formdata = this.getValue(this.person_copy);
              this.postValue('person', '参与方信息二', formdata);
            }
          }
          console.log(formdata);
          this.next = false;
          bus.$emit('parNext', 4);
        }
      }
    },
    /*保存案例*/
    save() {
      let postData = qs.stringify({
        caseNumber: this.caseNumber
      });
      this.$http.post(
          '/nais/nais/nn',
          postData, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        )
        .then((res) => {
          this.$message({
            message: this.caseNumber + "案例创建成功",
            type: 'success',
            center: true,
            duration: 2000
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    lastStep() {
      bus.$emit('parLast', 2);
    }
  },
  created() {
    let length1 = arrayData.data1.person.length;
    for (let i = 0; i < length1; i++) {
      arrayData.data1.person[i].value = '';
    }
    let length2 = arrayData.data1.person_copy.length;
    for (let i = 0; i < length2; i++) {
      arrayData.data1.person_copy[i].value = '';
    }
    let length3 = arrayData.data1.car.length;
    for (let i = 0; i < length3; i++) {
      arrayData.data1.car[i].value = '';
    }
    let length4 = arrayData.data1.car_copy.length;
    for (let i = 0; i < length4; i++) {
      arrayData.data1.car_copy[i].value = '';
    }
    let length5 = arrayData.data1.twoWheel.length;
    for (let i = 0; i < length5; i++) {
      arrayData.data1.twoWheel[i].value = '';
    }
    let length6 = arrayData.data1.twoWheel_copy.length;
    for (let i = 0; i < length6; i++) {
      arrayData.data1.twoWheel_copy[i].value = '';
    }
    this.person = arrayData.data1.person;
    this.person_copy = arrayData.data1.person_copy;
    this.car = arrayData.data1.car;
    this.car_copy = arrayData.data1.car_copy;
    this.twoWheel = arrayData.data1.twoWheel;
    this.twoWheel_copy = arrayData.data1.twoWheel_copy;
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('participantsNum', msg => {
      this.participantsNum = msg;
    });
    bus.$on('caseNumber', msg => {
      this.car[0].value = msg;
      this.car_copy[0].value = msg;
      this.person[0].value = msg;
      this.person_copy[0].value = msg;
      this.twoWheel[0].value = msg;
      this.twoWheel_copy[0].value = msg;
      this.caseNumber = msg;
    })
  }
}
</script>

<style scoped>
.parForm {
  width: 98%;
  height: 89%;
  margin-top: 0.5%;
  background-color: #F5F7FA;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.formDo {
  height: 10%;
  width: 800px;
  margin-top: 10px;
  display: flex;
  padding-left: 8%;
}

.formDo .el-button {
  height: 40px;
  margin-left: 20px;
}

.formMsg {
  width: 100%;
  height: 78%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  overflow-y: scroll;
}

.formButton {
  width: 100%;
  height: 10%;
  margin-top: 1%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-form-item {
  width: 33%;
  font-size: 12px;
}

.el-form-item__content {
  width: calc(100% - 55%);
}

.el-input {
  width: 100%;
}

.el-select {
  width: 100%;
}
</style>
<style>
.parForm .el-form-item__label {
  font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/data/newCase_par.vue